
$(document).ready(function() {
    help.init($('body'));
    // if (window.introJs) {
    //     introJs().addHints();
    // }
});

$(document).on('content-ready', function(ev, container) {
    container.find('.help-message-container .help-message').on('hidden.bs.collapse', function () {
        var messageContainer = $(this).closest('.help-message-container');
        messageContainer.removeClass('show-help');
        connection.getJson("/Help/HideHelp", {
            data: { tpl: messageContainer.attr('data-tpl') },
        });
    });
    container.find('.help-message-container .help-message').on('show.bs.collapse', function () {
        var messageContainer = $(this).closest('.help-message-container');
        messageContainer.addClass('show-help');
        connection.getJson("/Help/ShowHelpBox", {
            data: { tpl: messageContainer.attr('data-tpl') },
        });
    });
    container.find('.close-version-info').click(function(ev) {
        connection.getJson("/Help/HideHelp", {
            data: { tpl: $(ev.currentTarget).attr('data-version') },
        });
        $(ev.currentTarget).closest('.card').remove();
    });
});

var help = {
    selectors: null,

    // startIntroHelp() {
    //     if (window.introJs) {
    //         var instance = introJs().setOption("nextLabel", " > ");
    //         instance.setOption("prevLabel", " < ");
    //         instance.setOption("doneLabel", "schliessen");
    //         instance.setOption("skipLabel", "überspringen");
    //         instance.start();
    //     }
    // },

    init: function(container) {
        help.selectors = container.find('[data-help]');
        $('<a href="#" class="btn btn-info"><i class="fa bi-question-circle-fill"></i></a>').appendTo(help.selectors).click(help.showHelp);
    },

    showHelp: function() {
        var me = $(this);
        var helpId = me.parent('[data-help]').attr('data-help');

        var dialogEl = notification.notifyPopup('Hilfe', '<div class="help-content" data-action="/Help/Save/'+helpId+'"></div>', {
            width: '800px'
        });
        notification.addButton(dialogEl, {
            caption: "Schliessen",
            cssClass: "btn btn-danger",
            callback: function() {
                if (dialogEl.find('.htmlEditor').length == 1) {
                    connection.saveForm(dialogEl.find('.help-content'), function() {
                        notification.close(dialogEl);
                    });
                } else {
                    notification.close(dialogEl);
                }
            }
        });
        connection.getHtmlPart('/Help/ShowHelp/'+helpId, {
            onSuccess: function(data) {
                dialogEl.find('.help-content').html(data);
                dialogEl.find('.htmlEditor').ckeditor();
            }
        });
        $('body>.modal').on('hide.bs.modal', function (e) {
            if ($(dialogEl).find('.htmlEditor').length == 1) {
                connection.saveForm($(dialogEl), function() {
                    $(dialogEl).dialog("close");
                });
            }
        });

        // var ref = me.offset();
        // $('.helper-box').remove();
        // var dialogEl = $('<div class="help-content" data-action="/Help/Save/'+helpId+'"></div>');
        //
        // dialogEl.dialog({
        //     draggable: true,
        //     resizable: false,
        //     modal: false,
        //     title: 'Hilfe',
        //     minHeight: 0,
        //     width: 500,
        //     dialogClass: 'helper-box',
        //     closeText: '<i class="fa bi-x-lg"></i>',
        //     position: [ref.left - 478, ref.top + 22],
        //     buttons: [{
        //         text: "Schliessen",
        //         click: function() {
        //             if (dialogEl.find('.htmlEditor').length == 1) {
        //                 connection.saveForm(dialogEl, function() {
        //                     $(dialogEl).dialog("close");
        //                 });
        //             } else {
        //                 $(dialogEl).dialog("close");
        //             }
        //         }
        //     }]
        // });
        //
        // connection.getHtmlPart('/Help/ShowHelp/'+helpId, {
        //     onSuccess: function(data) {
        //         // dialogEl.find('.help-content').html(data);
        //         dialogEl.html(data);
        //         dialogEl.find('.htmlEditor').ckeditor();
        //     }
        // });
    }

};
window.help = help;
